import {styles} from "../../stylesheets/simulateurs.css";
import TextfieldNumber from "../textfields/textfield.number";
import React from "react";
import {ToolTipPerso} from "../selects/tooltip_perso";

// example of component use:
//      <LcbFtQuestion
//          handleChange={handleChange}
//          setFormaliteArt204={setFormaliteArt204}
//      />

const LcbFtQuestion = (props) => {

    return (
        <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
                Formalités prévues au titre de la recherche « LCB-FT » :
                <ToolTipPerso
                    title={
                        'Le nombre indiqué est multiplié par le coût de la formalité au titre de l’Art 204 du tableau 5 « Obtention de tout document » et se rajoutera au montant de votre provision sur frais'
                    }
                />
            </div>
            <TextfieldNumber
                handleChange={props.handleChange}
                type={"number"}
                placeholder={"Indiquer le nombre de formalités"}
                setter={props.setFormaliteArt204}
                reduxKey={"formalite_art_204"}
                max={199}
            />
        </div>
    );
};

export default LcbFtQuestion;
